import UserService from './index.js';

const userManager = new UserService();

export default userManager;
